const CLASS_TOKENS_KEY = 'classes';
const LEGACY_CLASS_TOKEN_KEY = 'class';

function normalizeTokens(tokens = []) {
  return [...new Set(tokens
    .filter((token) => typeof token === 'string')
    .map((token) => token.trim())
    .filter(Boolean))];
}

export function getStoredClassTokens() {
  let tokens = [];

  try {
    const storedTokens = JSON.parse(localStorage.getItem(CLASS_TOKENS_KEY) || '[]');
    if (Array.isArray(storedTokens)) {
      tokens = storedTokens;
    }
  } catch (error) {
    console.warn('Unable to read saved teaching-group links:', error);
  }

  const legacyToken = localStorage.getItem(LEGACY_CLASS_TOKEN_KEY);
  const normalizedTokens = normalizeTokens([...tokens, legacyToken]);

  if (normalizedTokens.length) {
    localStorage.setItem(CLASS_TOKENS_KEY, JSON.stringify(normalizedTokens));
  }

  return normalizedTokens;
}

export function addStoredClassTokens(tokens) {
  const updatedTokens = normalizeTokens([...getStoredClassTokens(), ...tokens]);
  localStorage.setItem(CLASS_TOKENS_KEY, JSON.stringify(updatedTokens));

  // Keep the original key populated so an older deployed build can still open
  // at least the most recently added class.
  if (updatedTokens.length) {
    localStorage.setItem(LEGACY_CLASS_TOKEN_KEY, updatedTokens[updatedTokens.length - 1]);
  }

  return updatedTokens;
}

export function removeStoredClassToken(token) {
  const updatedTokens = getStoredClassTokens().filter((savedToken) => savedToken !== token);

  if (updatedTokens.length) {
    localStorage.setItem(CLASS_TOKENS_KEY, JSON.stringify(updatedTokens));
    localStorage.setItem(LEGACY_CLASS_TOKEN_KEY, updatedTokens[updatedTokens.length - 1]);
  } else {
    clearStoredClassTokens();
  }

  return updatedTokens;
}

export function clearStoredClassTokens() {
  localStorage.removeItem(CLASS_TOKENS_KEY);
  localStorage.removeItem(LEGACY_CLASS_TOKEN_KEY);
}

export function getClassTokensFromUrl(url) {
  const parsedUrl = typeof url === 'string' ? new URL(url) : url;
  return normalizeTokens(parsedUrl.searchParams.getAll('class'));
}
